export function ContactUsDescription({ className }: { className?: string }) {
  return (
    <div>
      <p className={`text-justify font-light text-13 leading-25 text-gray-263341 ${className}`}>
        با سلام <br />
        از اینکه در راستای بهبود خدمت رسانی لیدوماتریپ نظراتتان را مطرح می کنید بسیار سپاسگزاریم.
        <br />
        مشتاقانه منتظر شنیدن دیدگاه های شما بوده و در لحظه دیدن پیامتان پاسخ گو خواهیم بود.
      </p>
    </div>
  );
}
